import { getSpcClientIdCookie } from '@shopee-user/authentication-utils';
import { EnvConfig, LocaleDomainSuffixConfig } from '@shopee-user/global';
import {
  isWebBridgeSupported,
  getPlatformType,
  config,
  PlatformType,
  getUserLanguage,
} from '@shopee-user/platform';
import { Layout } from '@shopee-user/layout-responsive';
import { appendQueryToUrl } from '@shopee/url-util';
import type {
  RedirectWithToCNonceProps,
  RedirectAfterOneCredentialDelinkProps,
} from '@shopee-user/business-customization-types';
import {
  LoginSignupTrackingContext,
  saveLoginSignupTrackingContextToLocal,
} from '@tob/shared/tracking/utils';
import { AUTHENTICATION_ENTRY_URL } from '../constants';

enum RedirectSource {
  Android = 'android',
  iOS = 'ios',
  WebDesktop = 'pc',
  WebMobile = 'mobile',
}

const { ENV, LOCALE } = config;

const APP_SOURCE_MAP: Record<PlatformType, RedirectSource> = {
  [PlatformType.Android]: RedirectSource.Android,
  [PlatformType.iOS]: RedirectSource.iOS,
};

const WEB_SOURCE_MAP: Record<Layout, RedirectSource> = {
  [Layout.Desktop]: RedirectSource.WebDesktop,
  [Layout.Mobile]: RedirectSource.WebMobile,
};

export const redirectWithToCNonce = ({
  toCNonce,
  safelyRedirectToNextUrlFromQueryString,
  layout,
  trackingContext,
}: RedirectWithToCNonceProps & {
  trackingContext?: LoginSignupTrackingContext;
}) => {
  const url = `https://${EnvConfig[ENV].subDomainPrefix}spx.${LocaleDomainSuffixConfig[LOCALE]}/shipment/account/api/login`;
  const platformType = getPlatformType();

  if (trackingContext) {
    saveLoginSignupTrackingContextToLocal(trackingContext);
  }

  if (isWebBridgeSupported()) {
    location.href = appendQueryToUrl(url, {
      toc_nonce: toCNonce,
      lang: getUserLanguage(),
      spc_clientid: getSpcClientIdCookie(),
      source: platformType ? APP_SOURCE_MAP[platformType] : undefined,
    });
  } else {
    safelyRedirectToNextUrlFromQueryString({
      toc_nonce: toCNonce,
      spc_clientid: getSpcClientIdCookie(),
      source: WEB_SOURCE_MAP[layout],
    });
  }
};

export const redirectAfterOneCredentialDelink = ({
  query,
  replaceCurrentUrl,
}: RedirectAfterOneCredentialDelinkProps) => {
  const redirectUrl = appendQueryToUrl(AUTHENTICATION_ENTRY_URL, {
    ...query,
  });
  replaceCurrentUrl?.({
    url: redirectUrl,
    isHardcodedUrl: true,
  });
};
